import { Box, Grid, Checkbox, Typography } from '@mui/material';
import React, { useRef } from 'react';

import CheckboxIcon from '../../../../packages/common/shared-ui/src/icons/CheckboxIcon';
import CheckboxIconChecked from '../../../../packages/common/shared-ui/src/icons/CheckboxIconChecked';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';

const ResplanSettingsChecks = ({ settings, setSettings, changed }) => {
  const getLocalString = useTranslation();
  const employmentCheck = getLocalString(
    'AdminResourcePlan',
    'labels',
    'employmentCheck',
  );
  const overEmployment = getLocalString(
    'AdminResourcePlan',
    'labels',
    'overEmployment',
  );

  const handleEmploymentCheck = useRef(event => {
    setSettings(prevSettings => ({
      ...prevSettings,
      employmentCheck: event.target.checked,
    }));
    changed();
  }).current;

  const handleOverEmployment = useRef(event => {
    setSettings(prevSettings => ({
      ...prevSettings,
      overEmploymentProhibition: event.target.checked,
    }));
    changed();
  }).current;

  return (
    <>
      <Grid
        container
        wrap='nowrap'
        sx={{
          width: '100%',
          alignItems: 'center',
          marginBottom: 2,
        }}
      >
        <Grid>
          <Typography
            variant='h5'
            sx={{
              color: '#41424E',
            }}
          >
            {employmentCheck}
          </Typography>
        </Grid>
        <Grid size={3}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Checkbox
              disableRipple
              checked={settings.employmentCheck}
              onChange={handleEmploymentCheck}
              icon={<CheckboxIcon width='12' height='12' viewBox='0 0 12 12' />}
              checkedIcon={
                <CheckboxIconChecked
                  width='12'
                  height='12'
                  viewBox='0 0 12 12'
                />
              }
            />
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        wrap='nowrap'
        sx={{
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Grid>
          <Typography
            variant='h5'
            sx={{
              color: '#41424E',
            }}
          >
            {overEmployment}
          </Typography>
        </Grid>
        <Grid size={3}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Checkbox
              disabled
              disableRipple
              checked={settings.overEmploymentProhibition}
              onChange={handleOverEmployment}
              icon={<CheckboxIcon width='12' height='12' viewBox='0 0 12 12' />}
              checkedIcon={
                <CheckboxIconChecked
                  width='12'
                  height='12'
                  viewBox='0 0 12 12'
                />
              }
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ResplanSettingsChecks;
